import React from 'react';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { FormattedMessage } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import useStyles from './EarlyAccessButtons.styles';
import {
  setEarlyAccessError,
  setEarlyAccessLoading,
  setEarlyAccessSuccess,
} from '../../../../store/actions/EarlyAccessActions';
import {
  getIsEarlyAccessEmailValid,
  getEarlyAccessIsLoading,
} from '../../../../store/selectors/EarlyAccessPageState';

const EarlyAccessButtons = ({ canSubmit }) => {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const earlyAccessEmailIsValid = useSelector(getIsEarlyAccessEmailValid);
  const isLoading = useSelector(getEarlyAccessIsLoading);

  const onSubmit = async event => {
    event.preventDefault();
    try {
      dispatch(setEarlyAccessLoading());
      // Simulate API request with 2 second delay
      // await new Promise(resolve => setTimeout(resolve, 2000));
      await new Promise((resolve, reject) => {
        setTimeout(() => reject(new Error('Simulated API error')), 2000);
      });
      dispatch(setEarlyAccessSuccess());
    } catch (error) {
      dispatch(setEarlyAccessError());
    }
  };

  return (
    <div className={classes.buttons}>
      <Button
        disabled={!canSubmit || !earlyAccessEmailIsValid || isLoading}
        data-testid="reqSiginSubmitButton"
        variant="contained"
        color="primary"
        size="small"
        type="submit"
        className={classes.button}
        onClick={onSubmit}
      >
        {isLoading ? (
          <CircularProgress size={20} color="inherit" />
        ) : (
          <FormattedMessage id="earlyAccess.submit" />
        )}
      </Button>
    </div>
  );
};

EarlyAccessButtons.propTypes = {
  canSubmit: PropTypes.bool,
};
EarlyAccessButtons.defaultProps = {
  canSubmit: false,
};

export default EarlyAccessButtons;
